
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.958 2.065c0 1.157-.87 2.065-1.979 2.065C.871 4.13 0 3.222 0 2.065 0 .91.87 0 1.98 0c1.107 0 1.978.909 1.978 2.065zm0 3.718H0V19h3.958V5.783zm6.334 0H6.333V19h3.959v-6.94c0-3.882 4.75-4.212 4.75 0V19H19v-8.344c0-6.526-7.046-6.278-8.708-3.056V5.783z"}})])
          )
        }
      }
    